"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M14.885 2.5h-6.77C6.948 2.5 6 3.416 6 4.545v13.91c0 1.129.948 2.045 2.115 2.045h6.77c1.167 0 2.115-.916 2.115-2.046V4.545c0-1.129-.948-2.045-2.115-2.045zM11.5 19.682c-.702 0-1.27-.548-1.27-1.227 0-.68.568-1.228 1.27-1.228.702 0 1.27.549 1.27 1.227 0 .68-.568 1.228-1.27 1.228zm3.808-3.273H7.692V4.955h7.616v11.454z" }), "ResolutionSmall");
//# sourceMappingURL=ResolutionSmall.js.map